import seo_en from '@/assets/data/localizations/seo_en.json';
import seo_th from '@/assets/data/localizations/seo_th.json';
import seo_my from '@/assets/data/localizations/seo_my.json';
import seo_mnw from '@/assets/data/localizations/seo_mnw.json';

export default {
    langSEO: {
        en: seo_en,
        th: seo_th,
        my: seo_my,
        mnw: seo_mnw
    }
}